import axiosInstance from './axiosInstance';

class ApiService {
  constructor() {
    this.baseURL = axiosInstance.defaults.baseURL;
  }

  async request(endpoint, options = {}) {
    try {
      const response = await axiosInstance.request({
        url: endpoint,
        ...options,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async get(endpoint, config = {}) {
    const response = await axiosInstance.get(endpoint, config);
    return response.data;
  }

  async post(endpoint, data = null, config = {}) {
    const response = await axiosInstance.post(endpoint, data, config);
    return response.data;
  }

  async put(endpoint, data, config = {}) {
    const response = await axiosInstance.put(endpoint, data, config);
    return response.data;
  }

  async patch(endpoint, data, config = {}) {
    const response = await axiosInstance.patch(endpoint, data, config);
    return response.data;
  }

  async delete(endpoint, config = {}) {
    const response = await axiosInstance.delete(endpoint, config);
    return response.data;
  }
}

const apiService = new ApiService();
export default apiService;
